<h4 mat-dialog-title>{{data.title || 'Visualizar Documento'}}</h4>

<div mat-dialog-content>
    <object [safeSourceContent]="data.content" class="pdf" type="application/pdf" title="PDF"></object>
</div>

<div align="end" mat-dialog-actions>
    <button class="btn btn-outline-secondary" (click)="close(true)">
        @if (data.isFinalPreview) {
            <i class="fas fa-undo mr-2"></i>
            <span class="action-button long">Voltar para a edição do formulário</span>
            <span class="action-button short">Voltar</span>
        } @else {
            <span>Fechar</span>
        }
    </button>

    @if (data.isFinalPreview) {
        <button class="btn btn-primary" (click)="close()">
            <i class="fas fa-check mr-2"></i>
            <span class="action-button long">Prosseguir com o envio do formulário</span>
            <span class="action-button short">Prosseguir</span>
        </button>
    }
</div>
